<div [ngClass]="computedAvatarClassesSignal$()" [ngStyle]="computedAvatarStyleSignal$()">
	<span class="avatar-text" [style.fontSize.px]="sizeSignal$() * 0.4">{{ rawTextSignal$() || (initialsSignal$() | uppercase) }}</span>
</div>
